import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";

export default class FrameWarning extends SMap.Control.Visible {
	/**
	 * konstruktor
	 */
	$constructor() {
		this._dom = {
			container: node("div", { className: "framewarning map-control" }),
			icon: icon("frame-warning"),
		};
		this._dom.container.innerHTML = `<span>${_("frame.warning")} <a href="https://napoveda.seznam.cz/forum/threads/131163/1" title="${_("frame.moreInfo")}" target="_blank">${_("frame.moreInfo")}</a></span>`;
		this._dom.container.firstChild.before(this._dom.icon);
	}
}
